module.exports = __webpack_public_path__ + "img/footer-overlay.a2a88cd9.png";